import { Component, OnInit, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-overlay-filter',
  templateUrl: './overlay-filter.component.html',
  styleUrls: ['./overlay-filter.component.less']
})
export class OverlayFilterComponent implements OnInit {

  isOverlaysOn: boolean = true;
  showParcelBoundaries: boolean = false;
  showZipBoundaries: boolean = false;
  showCountyBoundaries: boolean = false;
  overlayFilterActiveSubscription: Subscription;
  closeOnClickRef: any;
  heatMapsChangedSubscription: any;
  overlayFiltersChangedSubscription: any;
  trafficLayerChangedSubscription: any;
  parcelBoundariesEnabled: boolean = false;

  constructor(public mapsSidebarService: MapsSidebarService, public elementRef: ElementRef) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.overlayFilterActiveSubscription = this.mapsSidebarService.overlayFilterActiveStream.subscribe((value)=> {
      value && document.addEventListener('click', this.closeOnClickRef, true);
    });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.overlayFiltersChangedSubscription = w.Events.subscribe('overlayFiltersChanged',()=>{
      console.log('filter change event');
      this.showZipBoundaries = w.mapData.showZipcode;
      this.showParcelBoundaries = this.parcelBoundariesEnabled = w.mapData.showLandParcel;
      this.showCountyBoundaries = w.mapData.showCounty;
      this.isOverlaysOn = w.mapData.overlayFilterActive;
      w.Events.publish('detectChanges');
    });

    this.heatMapsChangedSubscription = w.Events.subscribe('heatMapsChanged',(value)=>{
      w.setMapDataProperty('activeHeatMap', value? value: w.mapData.activeHeatMap);
      w.setMapDataProperty('isHeatMapsActive', value? true: false);
      w.toggleHeatMaps((w.mapData.isHeatMapsActive)? w.mapData.activeHeatMap : null);
    });

    this.trafficLayerChangedSubscription = w.Events.subscribe('trafficLayerChanged', (data)=>{
      if(data && data.toggle) {
        this.toggleOverlays(false);
      }
    });
  }

  toggleOverlays(event) {
    let w = (<any>window);
    let toggle = event.target? event.target.checked: event;
    this.isOverlaysOn = toggle;
    w.setMapDataProperty('overlayFilterActive', toggle);
    w.toggleHeatMaps((toggle && w.mapData.isHeatMapsActive)? w.mapData.activeHeatMap : null);
    this.toggleLayers(this.isOverlaysOn, true);
    toggle && w.mapData.showTrafficCount && w.toggleTraffic(false);
    w.Events.publish('detectChanges');
  }

  toggleLayers(toggle, isOverlayFilterChanged?) {
    let w = (<any>window);
    this.showParcelBoundaries && w.toggleLandParcel(toggle, isOverlayFilterChanged);
    this.showZipBoundaries && w.toggleZipcode(toggle, isOverlayFilterChanged);
    this.showCountyBoundaries && w.toggleCounty(toggle, isOverlayFilterChanged);
    w.localStorageHandler.updateMapDataLocalStorage();
  }

  toggleParcelBoundaries(event) {
    let w = (<any>window);
    this.showParcelBoundaries = !this.showParcelBoundaries;
    w.toggleLandParcel(this.showParcelBoundaries);
  }

  toggleZipBoundaries(event) {
    let w = (<any>window);
    this.showZipBoundaries = !this.showZipBoundaries;
    w.toggleZipcode(this.showZipBoundaries);
  }

  toggleCountyBoundaries(event) {
    let w = (<any>window);
    this.showCountyBoundaries = !this.showCountyBoundaries;
    w.toggleCounty(this.showCountyBoundaries);
  }

  closeOnOutsideClick(event: Event) {
    let w = (<any>window);
    if (event.target !== this.elementRef.nativeElement
      && !this.elementRef.nativeElement.contains(event.target)
      && !w.hasClass(event.target, 'layer-filter-sub-header')
      && !w.hasClass(event.target, 'toggle-layers-holder')
      && !w.hasClass(event.target, 'filter-counter')
      && !w.hasClass(event.target, 'filter-icon')
      && !w.hasClass(event.target, 'arrow-icon')) {
      this.closeOverlayFilter();
      document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closeOverlayFilter() {
    this.mapsSidebarService.showOverlayFilter = false;
    (<any>window).localStorageHandler.updateSideBarToLS();
    (<any>window).Events.publish('detectChanges');
  }

  resetFilters() {
    let w = (<any>window);
    w.mapData.isHeatMapsActive = false;
    w.toggleHeatMaps(null);
    this.showParcelBoundaries = this.showCountyBoundaries = this.showZipBoundaries = false;
    w.toggleAllOverlayBoundaries(false);
    this.toggleLayers(false);
    w.Events.publish('detectChanges');
  }

  isHeatMapsActive() {
    let w = (<any>window);
    return w.mapData? w.mapData.isHeatMapsActive: false;
  }

  toggleHeatMapSection(event) {
    let w = (<any>window);
    w.setMapDataProperty('isHeatMapsActive', event.target.checked);
    if(w.mapData.activeHeatMap) {
      (<any>window).toggleHeatMaps(w.mapData.activeHeatMap);
    }
    if(!w.mapData.isHeatMapsActive) {
      (<any>window).toggleHeatMaps(null);
    }
  }

  toggleHeatMaps(event) {
    let w = (<any>window);
    w.setMapDataProperty('isHeatMapsActive', true);
    w.setMapDataProperty('activeHeatMap', event.target.dataset.type);
    w.toggleHeatMaps(event.target.dataset.type);
  }

  isHeatMapSelected(type) {
    let w = (<any>window);
    return w.mapData.activeHeatMap === type;
  }

  isHeatMapsDisabled() {
    let w = (<any>window);
    return !w.mapData.activeHeatMap? !this.isOverlaysOn :
    !w.mapData.isHeatMapsActive || !this.isOverlaysOn;
  }

  removeSubscriptions() {
    this.overlayFilterActiveSubscription && this.overlayFilterActiveSubscription.unsubscribe();
    this.overlayFiltersChangedSubscription && this.overlayFiltersChangedSubscription.unsubscribe();
    this.heatMapsChangedSubscription && this.heatMapsChangedSubscription.unsubscribe();
    this.trafficLayerChangedSubscription && this.trafficLayerChangedSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/overlay-filter/overlay-filter.component.ts